import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { GroupMembers } from 'src/app/shared/models/group-members.model';
import { GroupService } from 'src/app/shared/services/group.service';
import { AuthService } from '../account/auth.service';
import { take } from 'rxjs/operators';
import {
  AddMemberRequest,
  AddMembers,
  RemoveMembers,
} from 'src/app/admin/group-setup/group.model';
import { Invitation } from 'src/app/shared/models/invitation.model';
import { InvitationsService } from 'src/app/shared/services/invitations.service';
import { Invite } from 'src/app/shared/models/invite.model';
import { User } from '../account/user.model';

@Component({
    selector: 'app-groups',
    templateUrl: './groups.component.html',
    styleUrls: ['./groups.component.scss'],
    standalone: false
})
export class GroupsComponent implements OnInit, AfterViewInit {
  isLoading: boolean = true;
  groupsArr: GroupMembers[] = [];
  pubGroupsArr: GroupMembers[] = [];
  invitations: Invitation[] = [];
  userId: string;
  User: User = null;
  groupId: number = 0;
  get hasVisibleGroups(): boolean {
    return [...this.groupsArr, ...this.pubGroupsArr].some(group => group.members?.length > 0 &&
      (this.groupId === 0 || this.groupId === group.groupId));
  }

  constructor(
    private _InvitationService: InvitationsService,
    public identityService: IdentityService,
    public globalService: GlobalService,
    private _router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private _groupService: GroupService
  ) {}

  async ngOnInit() {
    this.isLoading = true;

    if (this.route.snapshot.params.groupId)
      this.groupId = parseInt(this.route.snapshot.params.groupId);

      this.User = await this.authService.autoLogin(1);
      if (this.User != null)
      {
        this.userId = this.User.id;
        this.groupsArr = await this._groupService.getGroupMembersByUserId(
          this.userId
        );
        this.groupsArr.map((a) => {
          a['expanded'] = this.groupId > 0;
          if (a['presignedUrl'] == '')
            a['presignedUrl'] = 'assets/images/group-avatar.png';
        });
        this.pubGroupsArr = await this._groupService.getPublicGroupsByUserId(
          this.userId
        );
        this.pubGroupsArr.map((a) => {
          a['expanded'] = this.groupId > 0;
          if (a['presignedUrl'] == '')
            a['presignedUrl'] = 'assets/images/group-avatar.png';
        });
        this.invitations = await this._InvitationService.getInvitations(
          this.userId,
          true
        );
        this.invitations.map((a) => {
          a['resolved'] = false;
        });
        this.isLoading = false;
      }
      else
      {
        this.isLoading = false;
        this._router.navigate([this.globalService.subdomain + '/login']);
      }
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = this.globalService.Get('GROUPS');
    });
  }


  async Accept(invitation: Invitation) {
    var invite: Invite = new Invite();
    invite.userId = this.userId;
    invite.groupId = invitation['groupId'];
    invite.memberId = invitation['memberId'];
    invitation['process'] = true;
    await this._InvitationService.acceptInvitation(invite);
    this.groupsArr = await this._groupService.getGroupMembersByUserId(
      this.userId
    );
    this.pubGroupsArr = await this._groupService.getPublicGroupsByUserId(
      this.userId
    );
    invitation['resolved'] = true;
  }

  InvitationCount(): number {
    return this.invitations.filter(
      (a) => a['resolved'] == null || a['resolved'] == false
    ).length;
  }

  async Reject(invitation: Invitation) {
    var invite: Invite = new Invite();
    invite.userId = this.userId;
    invite.groupId = invitation['groupId'];
    invite.memberId = invitation['memberId'];
    await this._InvitationService.declineInvitation(invite);
    invitation['resolved'] = true;
  }

  async LeaveGroup(
    gindex: number,
    mindex: number,
    groupId: number,
    memberId: number
  ) {
    let rm: RemoveMembers = new RemoveMembers();
    rm.groupId = groupId;
    rm.memberList = [];
    rm.memberList.push(memberId);
    this.groupsArr[gindex].members.find((a) => a.memberId == memberId)[
      'process'
    ] = true;
    await this._groupService.removeMembersFromGroup(rm);
    this.pubGroupsArr = await this._groupService.getPublicGroupsByUserId(
      this.userId
    );
    this.groupsArr[gindex].members = this.groupsArr[gindex].members.filter(
      (a) => a.memberId != memberId
    );
    this.groupsArr.map((a) => {
      a['pubGroupsArr'] = false;
    });
  }

  async JoinGroup(
    gindex: number,
    mindex: number,
    groupId: number,
    memberId: number
  ) {
    let ad: AddMembers = new AddMembers();
    ad.groupId = groupId;
    ad.user = this.userId;
    ad.isLeader = false;
    ad.memberList = [];
    ad.memberList.push(memberId);
    this.pubGroupsArr[gindex].members.find((a) => a.memberId == memberId)[
      'process'
    ] = true;
    await this._groupService.addMembersToGroup(ad);
    this.groupsArr = await this._groupService.getGroupMembersByUserId(
      this.userId
    );
    this.pubGroupsArr[gindex].members = this.pubGroupsArr[
      gindex
    ].members.filter((a) => a.memberId != memberId);
    this.groupsArr.map((a) => {
      a['expanded'] = false;
    });
  }

  async RequestGroup(
    gindex: number,
    mindex: number,
    groupId: number,
    memberId: number
  ) {
    if (this.pubGroupsArr[gindex].members[mindex]['answer'] == null)
      this.pubGroupsArr[gindex].members[mindex]['answer'] = '';

    let ad: AddMemberRequest = new AddMemberRequest();
    ad.groupId = groupId;
    ad.user = this.userId;
    ad.memberId = memberId;
    ad.answer = this.pubGroupsArr[gindex].members[mindex]['answer'];
    this.pubGroupsArr[gindex].members.find((a) => a.memberId == memberId)[
      'process'
    ] = true;
    await this._groupService.addMemberRequestToGroup(ad);
    this.pubGroupsArr[gindex].members
      .filter((a) => a.memberId == memberId)
      .map((a) => {
        a['requested'] = true;
        a['process'] = false;
        delete a['join'];
      });
    this.groupsArr.map((a) => {
      a['expanded'] = false;
    });
  }

  browseMembers(groupId) {
    this._router.navigate(['groups/view-members/' + groupId]);
  }

  goHome() {
    this.globalService.clearCurCache = false;
    this._router.navigate(['/home']);
  }

  OpenPoints(userId: string) {
    this.globalService.clearCurCache = false;
    this._router.navigate(['/add-point/' + userId + '/1']);
  }
}
